import React from 'react';
import { ExtraData, LeftText } from './styles/common.styles';

const IndoorLocation = ({ indoorLocation }) => {
  if (!indoorLocation) return null;
  return (
    <ExtraData ellipsis data-name="indoor-location">
      <LeftText ellipsis>Indoor Location: {indoorLocation}</LeftText>
    </ExtraData>
  );
};

export default IndoorLocation;
